import { BaseConnector } from './baseConnector';

class NotificationContentSpecificationConnector extends BaseConnector {
  getNotificationContentSpecification(hearingId) {
    var url = `${this.baseApiUrl}/hearing/${hearingId}/notificationContentSpecification`;
    return this.authFetch(url);
  }

  updateNotificationContent(
    hearingId,
    notificationContentSpecificationId,
    dtos,
  ) {
    var url = `${this.baseApiUrl}/hearing/${hearingId}/notificationContentSpecification/${notificationContentSpecificationId}/notificationContent`;
    return this.authPatch(url, dtos);
  }
}

export { NotificationContentSpecificationConnector };
